import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { RemoteDescription, VorOrtDescription } from '@vi-iot/client';
import { ViessmannUIModule } from '@vi-iot/ui/index';
import { CommonStandaloneModule } from 'src/app/shared/common-standalone.module';

@Component({
  selector: 'app-additional-service-expandable',
  standalone: true,
  imports: [CommonStandaloneModule, MatExpansionModule, ViessmannUIModule],
  templateUrl: './additional-service-expandable.component.html',
  styleUrl: './additional-service-expandable.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdditionalServiceExpandableComponent {
  @Input() configStyle: { colorClass: string; isRemote: boolean; title: string; subTitle: string };

  vorOrtDescription: string[] = VorOrtDescription;
  remoteDescription: string[] = RemoteDescription;
  expanded: boolean;
}
